import { render } from "./TeachingPlanApproverTab.vue?vue&type=template&id=15441e1e&scoped=true&ts=true"
import script from "./TeachingPlanApproverTab.vue?vue&type=script&lang=ts"
export * from "./TeachingPlanApproverTab.vue?vue&type=script&lang=ts"

import "./TeachingPlanApproverTab.vue?vue&type=style&index=0&id=15441e1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15441e1e"]])

export default __exports__